import '@fontsource-variable/inter/wght.css'
import ReactDOM from 'react-dom/client'
import { initI18n } from './i18n'
import App from './app/App'
import ErrorBoundary from './components/ErrorBoundary'

const root = ReactDOM.createRoot(document.getElementById('root'))

initI18n().then(() => {
	root.render(
		<ErrorBoundary>
			<App />
		</ErrorBoundary>
	)
})
